import Head from 'next/head';
import { useRouter } from 'next/router';
import Script from 'next/script';

const TRACKING_ENABLED_QUERY_PARAM_VALUE = '1';

const CCPAScripts = () => {
  const router = useRouter();

  const isEnabled =
    (router.query?.trackingenabled ?? TRACKING_ENABLED_QUERY_PARAM_VALUE) ===
    TRACKING_ENABLED_QUERY_PARAM_VALUE;

  return (
    <>
      <Head>
        <script
          key="optanon-api-bootstrap"
          // eslint-disable-next-line react/no-danger
          dangerouslySetInnerHTML={{
            __html: `
            !function(n){var o=window,a="cbsoptanon",c="cmd",d="config";o[a]=o[a]?o[a]:{},o[a][c]=o[a][c]?o[a][c]:[],o[a][d]=o[a][d]?o[a][d]:[],["onIframesReady","onFormsReady","onScriptsReady","onAdsReady"].forEach(function(n){o[a][n]=o[a][n]||function(){var d=arguments;o[a][c].push(function(){o[a][n].apply(o[a],d)})}})}();
          `
          }}
        />
        <script
          key="optanon-api-settings"
          // eslint-disable-next-line react/no-danger
          dangerouslySetInnerHTML={{
            __html: `
              // setting tfcd on cbsoptanon references googletag.
              // add this here prevents a race condition where it may not be defined yet.
              var googletag = googletag || {};
              googletag.cmd = googletag.cmd || [];

              (function()
              {
                let tfcd = false;
      
                const a = document.cookie.match('(^|;)\\\\s*MemberName\\\\s*=\\\\s*([^;]+)');
                if(a && a.length === 3)
                {
                  tfcd = !!parseInt(new URLSearchParams(a.pop()).get('tfcd') || '0')
                }
        
                typeof cbsoptanon !== 'undefined' && cbsoptanon.config.push({
                  enableServices: false,
                  setNpaOnConsentChange: true,
                  tfcd 
                });
              })();
            `
          }}
        />
      </Head>

      {isEnabled && (
        <>
          <Script
            id="onetrust-cmp"
            src="https://cdn.cookielaw.org/scripttemplates/otSDKStub.js"
            data-domain-script="b99e4235-f916-440f-9591-b220fe2f3fa2"
            strategy="afterInteractive"
          />
          <Script
            id="optanon-standardized-api"
            src="https://production-cmp.isgprivacy.cbsi.com/dist/optanon-v1.1.0.js"
            strategy="afterInteractive"
          />
        </>
      )}
    </>
  );
};

export default CCPAScripts;
